import _ from 'underscore';
import { AdsStudioErrorBase } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

export class AdsStudioODataError extends AdsStudioErrorBase {
  constructor({
    message, originError, originErrors, bulkupsertErrors,
    errorProcessor, // use processor to extend the error object with anything needed
    ...rest // additional data passed to processor
  }) {
    let errors = [];
    let status = '';
    if (originError) {
      errors = originError.errors || [];
      status = originError.status || '';
    } else if (originErrors) {
      errors = originErrors;
    } else if (bulkupsertErrors) {
      errors = bulkupsertErrors;
    }

    const { Code, Message, Property } = _.first(errors) || {};
    const errorCode = Code || 'Unknown';

    const params = { ...rest, errorMessage: Message || undefined, errorProperty: Property || undefined };
    super({
      message, originError, errorCode, errorProcessor, ...params,
    });

    this.errors = errors;
    this.status = status;
  }
}
